import React from 'react'
import ReactDOM from 'react-dom'
import Slider from './introduction/slider'
import device from './device'

let mobileOS = device.getMobileOperatingSystem()
let sliderCompatible = !(mobileOS === 'Windows Phone' || mobileOS === 'Android')
let mountNode = $('#introduction .slider').get(0)
if(mountNode && sliderCompatible){
  ReactDOM.render(<Slider />, mountNode)
}



/** WEBPACK FOOTER **
 ** assets/javascripts/introduction.js
 **/